import { Dropdown, Menu, message, Space } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useModel } from '@umijs/max'
import * as auth from '../../utils/auth';

const RightContent = () => {

  const { initialState } = useModel('@@initialState')

  const menu = () => {
    const logout = () => {
      auth.logout()
      message.success('已退出登陆');
    };
    return (
      <Menu
        items={[
          {
            key: '1',
            label: <span onClick={logout}>退出登陆</span>,
          },
        ]}
      />
    );
  };

  return (
    <>
      <Dropdown overlay={menu}>
        <a onClick={(e) => e.preventDefault()}>
          <Space>
            {initialState?.userinfo?.username}
            <DownOutlined />
          </Space>
        </a>
      </Dropdown>
    </>
  );
};

export default RightContent;
